import { MenuButton, useMenuState } from '@vtex/admin-ui'
import { BenefitMenu, Options } from '../../BenefitMenu'
import { useIntl } from 'react-intl'
import { messages } from './messages'

type ActionMenuProps = {
  selected: string
  onChange: (name: string) => void
  options: Options
}

export function BenefitSelectorActionMenu(props: ActionMenuProps) {
  const { onChange, selected, options } = props

  const state = useMenuState()

  const { $t } = useIntl()

  return (
    <>
      <BenefitMenu
        selected={selected}
        state={state}
        onAdd={onChange}
        options={options}
      />
      <MenuButton
        state={state}
        labelHidden
        size="large"
        variant="neutralTertiary"
        aria-label={$t(messages.actionMenuAria)}
      />
    </>
  )
}
